const article = {
  id: 8,
  category: "Transformation digitale",
  title: "Transformation digitale : Comment en faire un levier de croissance ?",
  text: "Au-delà du site vitrine, le numérique doit servir votre stratégie. Nos experts vous guident pour une digitalisation efficace et rentable.",
  link: "/articles/transformation-digitale-levier-croissance",
  date: "Octobre 2025",
  highlight: "Cas clients : +20% de productivité grâce au digital"
};

export default article;
